import { z } from 'zod';
import { entityMetaSchema } from '../../utils';

/**
 * Envelope every column subtype shares. Only infrastructure lives here — the
 * subtype's own settings go in `props`, the way grid, tab and section are laid
 * out.
 *
 * `children` holds widget ids in the store and whole widgets — plus grids and
 * tabs — while the structure adapter still has the denormalized tree, hence
 * `unknown[]`.
 */
export const columnBaseSchema = z.object({
    id: z.string(),
    parentId: z.string(),
    children: z.array(z.unknown()),
    entityType: z.literal('column'),
    version: z.number().int().nonnegative(),
    meta: entityMetaSchema,
});
